import React, { useMemo, useLayoutEffect, useRef } from 'react'
import * as THREE from 'three'
import { useFrame } from 'react-three-fiber'
import { Text3D } from '@react-three/drei'
import alienFont from '../fonts/Aliens ate my mum_Regular.json'
import animals from '../fonts/3D Animals_Regular.json'
import Social_links from '../fonts/Social Circles_Regular.json'

import gsap from 'gsap'

const MyName = ({
  children,
  font,
  vAlign = 'center',
  hAlign = 'center',
  size = 1.5,
  color = '#7cb342',
  ...props
}) => {
  const config = useMemo(
    () => ({
      size: 2.5,
      height: 1,
      curveSegments: 0.5,
      bevelEnabled: true,
      bevelThickness: 0.5,
      bevelSize: 0.1,
      bevelOffset: 0,
      bevelSegments: 8,
    }),
    []
  )
  useLayoutEffect(() => {
    const size = new THREE.Vector3()
    meshRef.current.geometry.computeBoundingBox()
    meshRef.current.geometry.boundingBox.getSize(size)
    meshRef.current.position.x =
      hAlign === 'center' ? -size.x / 2 : hAlign === 'right' ? 0 : -size.x
    meshRef.current.position.y =
      vAlign === 'center' ? -size.y / 2 : vAlign === 'top' ? 0 : -size.y
  }, [children])

  const clickNav = e => {
    console.log(123)

    let p = meshRef.current.position
    gsap.to(p, {
      duration: 2.5,
      ease: 'power4.out',
      z: p.z - 10,
    })
  }

  const meshRef = useRef(null)
  useFrame(() => {
    // meshRef.current.rotation.y += 0.004
    meshRef.current.rotation.x += 0.004
    // meshRef.current.rotation.z += 0.004
  })

  const choseFont = () => {
    if (font) {
      console.log(font)
      switch (font) {
        case 'animals':
          return animals
          break
        case 'Social_links':
          return Social_links
          break
        default:
          return alienFont
          break
      }
    } else {
      return alienFont
    }
  }

  return (
    <group
      onClick={e => clickNav(e)}
      {...props}
      scale={[0.1 * size, 0.1 * size, 0.1]}
    >
      <Text3D castShadow ref={meshRef} font={choseFont()} {...config}>
        {children}
        <meshStandardMaterial color={color} attach='material' />
      </Text3D>
    </group>
  )
}
export default MyName
